import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageService, SlbSeverity } from '@slb-dls/angular-material/notification';
import { CustomCalendarComponent } from '../custom-calendar/custom-calendar.component';
import { EventData, EventDataIteration, EventDetails, Media, WORKFLOW_DETAILS } from '../../shared/models/eventDetails';
import { CameraProfileService } from '../../shared/services/camera-profile.service';
import { BehaviorSubject, Subject, catchError, filter, of, switchMap, takeUntil, tap } from 'rxjs';
import { CameraStatus } from '../../shared/constants/enum';
import {
  BPOS,
  BPOS_UNIT,
  BVEL,
  BVEL_UNIT,
  CUSTOM,
  DAY,
  EVENTERROR,
  EVENT_CSV_DOWNLOAD_HEADING,
  EVENT_FILTER,
  EXCLUDED,
  FILE_DOWNLOAD_ERROR,
  HOUR,
  NONE,
  RPM,
  RPM_UNIT,
  SPPA,
  SPPA_UNIT,
  WEEK,
  WORKFLOW,
  WORKFLOW_ALL,
} from '../../shared/constants/camera-profile-constant';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TimeZoneService } from '../../shared/services/time-zone.service';
import { TimeZone } from '../../shared/models/dashabordAlertData';
import { PopUpService } from '../../shared/services/pop-up.service';
import { DashboardService } from '../../shared/services/dashboard.service';
import { DashboardConstants } from '../../shared/constants/dashboard-constants';
import { CameraConstants } from '../../../app/shared/constants/camera-constant';
import { UserSettingsService } from '../../../app/shared/services/user-settings.service';
import { UnitsData } from '../../../app/shared/models/unit';

@Component({
  selector: 'app-alerts-container',
  templateUrl: './alerts-container.component.html',
  styleUrls: ['./alerts-container.component.scss'],
})
export class AlertsContainerComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() setReviewCategory = new EventEmitter<string>();
  public reviewCategory = 'All';
  public violationData: EventDetails[];
  public viewMode = 'grid';
  public selectedFiles: EventDetails[];
  public checkAll: boolean;
  public violationDataList: EventDetails[];
  public dayMode: string;
  public startDate: Date;
  public endDate: Date;
  public controllerId: string;
  public gatewayId: string;
  public isLoading: boolean;
  public currentZone = '';
  public refreshedTimezone = '';
  public totalRecords = 0;
  public reviewFilterList = EVENT_FILTER;
  public paginatedData: PageEvent = JSON.parse(JSON.stringify(DashboardConstants.DEFAULT_PAGINATION));
  public isDownloadStarted = false;
  public strikeRedzone = false;
  public strikePPE = false;
  public noEventData: boolean;
  public eventId: number;
  public workflows = WORKFLOW;
  private eventStartDate: string;
  private SECONDS_IN_HOUR = 3600 * 1000;
  private HOUR = 1;
  private DAY = 24;
  private WEEK = 168;
  private cameraName: string;
  private destroyed = new Subject();
  private previousDaymode: string;
  private pageNumber: number;
  private recordsPerPage: number;
  private eventTime: Date;
  private fromDashboard = false;
  private event: string[];
  private gridState = new BehaviorSubject(this.paginatedData);
  private gridState$ = this.gridState.asObservable();
  private cameraStatus: CameraStatus;
  private rigName: string;
  private showAllEvents: string;
  private isPaginated = false;
  private unitSelected: UnitsData;

  constructor(
    private dialog: MatDialog,
    private cameraProfileService: CameraProfileService,
    private dashboardService: DashboardService,
    private timeZoneService: TimeZoneService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private popupService: PopUpService,
    private datePipe: DatePipe,
    private userSettingService: UserSettingsService
  ) {
    this.violationDataList = this.violationData;
    this.route.params
      .pipe(
        tap(params => {
          if (params) {
            this.gatewayId = params.gateway;
            this.controllerId = params.controllerId;
            this.cameraName = params.cameraName;
            this.cameraStatus = params.cameraStatus;
            this.rigName = params.rigName.replace(/[\*+]/g, ' ');
          }
        }),
        switchMap(() =>
          this.timeZoneService.timeZoneDetails$.pipe(
            filter((zone: TimeZone) => !!Object.keys(zone).length),
            tap((_zone: TimeZone) => (this.currentZone = this.timeZoneService.getTimeZone()))
          )
        ),
        switchMap(() =>
          this.cameraProfileService.selectedEventTime$.pipe(
            tap((eventTime: string) => {
              if (eventTime) {
                this.fromDashboard = true;
                this.eventTime = new Date(eventTime);
              } else if (sessionStorage.getItem('selectedCameraEventDate')) {
                const sessionEventTime = sessionStorage.getItem('selectedCameraEventDate')?.toString();
                if (sessionEventTime) {
                  this.fromDashboard = true;
                  this.eventTime = new Date(sessionEventTime);
                }
              }
            })
          )
        ),
        switchMap(() =>
          this.cameraProfileService.isAdmin$.pipe(
            tap(isAdminData => {
              if (!isAdminData || isAdminData === 'false') {
                this.reviewFilterList = this.reviewFilterList.filter(review => review.toLowerCase() !== EXCLUDED);
              }
            })
          )
        ),
        switchMap(() =>
          this.userSettingService.unitSelected$.pipe(
            tap((value: string) => {
              this.unitSelected = JSON.parse(value);
            })
          )
        ),
        takeUntil(this.destroyed)
      )
      .subscribe();
  }

  ngOnInit(): void {
    this.getCameraWorkflow();
    this.getqueryParameters();
    this.cameraProfileService.resetAnalyticsSelection();
    this.isLoading = true;
    this.selectedFiles = [];
    this.noEventData = false;
    this.event = WORKFLOW_ALL;
    this.pageNumber = DashboardConstants.PAGE_NUMBER;
    this.recordsPerPage = DashboardConstants.RECORDS_PER_PAGE;
    this.assignEvent(false);
    if (!this.fromDashboard) {
      this.dayMode = DAY;
      this.previousDaymode = DAY;
      this.dayMode = this.eventId === 0 ? this.dayMode : CUSTOM;
      let endDate = new Date(this.eventStartDate);
      endDate = new Date(endDate.setSeconds(endDate.getSeconds() + 2));
      this.endDate = this.eventId === 0 ? new Date() : endDate;
      let startDate = new Date(this.eventStartDate);
      startDate = new Date(startDate.setHours(startDate.getHours() - 24));
      this.startDate = this.eventId === 0 ? new Date() : startDate;
    } else {
      this.checkTimeRange();
    }
  }

  ngAfterViewInit(): void {
    if (!this.fromDashboard) {
      this.generateDate();
      this.getEvent();
    }
  }

  public switchView(event: { value: string }): void {
    this.viewMode = event.value;
  }

  public downloadSelectedFile(): void {
    const downloadUrls: number[] = [];
    if (this.selectedFiles && this.selectedFiles.length > 0) {
      this.selectedFiles.forEach(file => {
        const medias = file.media.filter((media: Media) => media.fileUrl);
        if (medias.length) {
          downloadUrls.push(file.eventId);
        }
      });
      if (downloadUrls && downloadUrls.length > 0) {
        this.downloadFiles(downloadUrls);
      } else {
        this.messageService.add({ severity: SlbSeverity.Error, summary: FILE_DOWNLOAD_ERROR });
      }
    }
  }

  public async openReviewPopup(): Promise<void> {
    if (this.selectedFiles && this.selectedFiles.length > 0) {
      await this.popupService.openEditReviewConfiguration(this.selectedFiles);
    }
  }

  public getSelectedFiles(value: EventDetails[]): void {
    this.selectedFiles = value;
    if (this.violationDataList.length > this.selectedFiles.length) {
      this.checkAll = false;
    } else if (this.violationDataList.length === this.selectedFiles.length) {
      this.checkAll = true;
    }
    this.updateSelection();
  }

  public checkAllFiles(): void {
    if (this.checkAll) {
      this.selectedFiles = this.violationDataList;
      this.violationDataList.map((data: EventDetails) => (data['isChecked'] = true));
      this.violationDataList = [...this.violationDataList];
    } else {
      this.violationDataList.map((data: EventDetails) => (data['isChecked'] = false));
      this.violationDataList = [...this.violationDataList];
      this.selectedFiles = [];
    }
    this.updateSelection();
  }

  public switchDays(event: { value: string }): void {
    this.previousDaymode = this.dayMode;
    this.dayMode = event.value;
    if (this.dayMode !== CUSTOM) {
      this.isLoading = true;
      this.selectedFiles = [];
      this.pageNumber = DashboardConstants.PAGE_NUMBER;
      this.recordsPerPage = DashboardConstants.RECORDS_PER_PAGE;
      this.totalRecords = 0;
      this.paginatedData = JSON.parse(JSON.stringify(DashboardConstants.DEFAULT_PAGINATION));
      this.generateDate();
    }
  }

  public customClick(): void {
    const dialogRef = this.dialog.open(CustomCalendarComponent, {
      width: '550px',
      data: {
        startDate: this.startDate,
        endDate: this.endDate,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.type === 'save') {
        this.startDate = result.dates.startDate;
        this.endDate = result.dates.endDate;
        this.isLoading = true;
        this.selectedFiles = [];
        this.pageNumber = DashboardConstants.PAGE_NUMBER;
        this.recordsPerPage = DashboardConstants.RECORDS_PER_PAGE;
        this.totalRecords = 0;
        this.paginatedData = JSON.parse(JSON.stringify(DashboardConstants.DEFAULT_PAGINATION));
        this.gridState.next(this.paginatedData);
        this.previousDaymode = CUSTOM;
      } else {
        this.dayMode = this.previousDaymode;
      }
    });
  }

  public getPaginatedData(event: PageEvent): void {
    if (this.pageNumber !== event.pageIndex + 1 || this.recordsPerPage !== event.pageSize) {
      this.paginatedData = event;
      this.pageNumber = event.pageIndex + 1;
      this.recordsPerPage = event.pageSize;
      this.selectedFiles = [];
      this.gridState.next(this.paginatedData);
    }
  }

  public getFilteredReviews(): void {
    this.pageNumber = 1;
    this.recordsPerPage = DashboardConstants.RECORDS_PER_PAGE;
    this.totalRecords = 0;
    this.selectedFiles = [];
    this.paginatedData = JSON.parse(JSON.stringify(DashboardConstants.DEFAULT_PAGINATION));
    this.setReviewCategory.emit(this.reviewCategory);
    this.gridState.next(this.paginatedData);
  }

  public assignEvent(fromClick: boolean): void {
    this.pageNumber = 1;
    const getNCWorkflow = this.workflows.filter(data => !data.checked);
    if (getNCWorkflow.length === 0) {
      this.noEventData = true;
      this.violationDataList = [];
      this.event = [];
    } else {
      if (getNCWorkflow.length === this.workflows.length) {
        this.event = WORKFLOW_ALL;
      } else {
        this.event = getNCWorkflow.map(data => data?.value);
      }
      if (fromClick) {
        this.gridState.next(this.paginatedData);
      }
    }
    this.paginatedData.pageIndex = 0;
  }

  public downloadCsvEventData(): void {
    const startTime = this.calculateTimeBasedOnTimezone(this.startDate);
    const endTime = this.calculateTimeBasedOnTimezone(this.endDate);
    const recordsPerPage = 10000;
    const pageNumber = 1;
    this.isDownloadStarted = true;
    this.messageService.add({ severity: SlbSeverity.Info, summary: CameraConstants.CSV_DOWNLOAD_WAIT_MSG, sticky: true, closable: false });
    let csvData = '';
    let blob = new Blob();

    this.cameraProfileService
      .getAllEventData(
        this.gatewayId,
        this.controllerId,
        startTime,
        endTime,
        pageNumber,
        recordsPerPage,
        this.reviewCategory.toLowerCase(),
        this.event,
        this.showAllEvents
      )
      .pipe(
        tap((value: EventDataIteration) => {
          const columnNames = EVENT_CSV_DOWNLOAD_HEADING;

          if (!value?.totalRecords || !columnNames?.length) {
            return;
          }
          const eventData: EventDetails[] = JSON.parse(JSON.stringify(value.data));
          csvData = this.convertToCsv(csvData, eventData, columnNames);
          if (value.index === 0) {
            blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
          } else {
            blob = new Blob([blob, csvData], { type: 'text/csv;charset=utf-8;' });
          }

          if (value.index === value.totalPages - 1) {
            this.downloadData(blob);
          }
        }),
        catchError(() => {
          this.messageService.clear();
          this.messageService.add({ severity: SlbSeverity.Error, summary: CameraConstants.CSV_DOWNLOAD_ERROR_MSG });
          this.isDownloadStarted = false;

          return of<EventDataIteration>({} as EventDataIteration);
        }),
        takeUntil(this.destroyed)
      )
      .subscribe();
  }

  public setEventId(): void {
    this.eventId = 0;
  }

  ngOnDestroy(): void {
    this.cameraProfileService.setEventTime('');
    this.destroyed.next(true);
    this.destroyed.complete();
  }

  private downloadFiles(eventId: number[]): void {
    this.cameraProfileService
      .downloadMediaAsZip(this.gatewayId, this.controllerId, eventId)
      .pipe(
        tap((data: string) => {
          if (data && data !== '') {
            this.downloadZipFile(data);
          } else {
            this.messageService.add({ severity: SlbSeverity.Error, summary: FILE_DOWNLOAD_ERROR });
          }
        }),
        catchError(err => {
          console.error(err);
          throw err;
        }),
        takeUntil(this.destroyed)
      )
      .subscribe();
  }

  private generateDate(): void {
    switch (this.dayMode) {
      case HOUR:
        this.getDate(this.HOUR);
        break;
      case DAY:
        this.getDate(this.DAY);
        break;
      case WEEK:
        this.getDate(this.WEEK);
        break;
    }
    if (this.event.length > 0) {
      this.gridState.next(this.paginatedData);
    } else {
      this.isLoading = false;
    }
  }

  private getDate(hour: number): void {
    if (hour) {
      this.endDate = new Date();
      this.startDate = new Date(new Date().getTime() - hour * this.SECONDS_IN_HOUR);
    }
  }

  private getEvent(): void {
    let startTime: string;
    let endTime: string;
    this.isLoading = true;
    this.gridState$
      .pipe(
        tap(() => {
          this.isPaginated = true;
        }),
        switchMap(() =>
          this.cameraProfileService.eventData$.pipe(
            tap(_value => {
              this.isLoading = true;
              this.showAllEvents = sessionStorage.getItem('showAllEvents') || '';
              startTime = this.calculateTimeBasedOnTimezone(this.startDate);
              endTime = this.calculateTimeBasedOnTimezone(this.endDate);
              this.selectedFiles = [];
              this.checkPagination(_value);
            }),
            switchMap(() =>
              this.cameraProfileService
                .getCameraEventData(
                  this.gatewayId,
                  this.controllerId,
                  startTime,
                  endTime,
                  this.pageNumber,
                  this.recordsPerPage,
                  this.reviewCategory.toLowerCase(),
                  this.event,
                  this.showAllEvents
                )
                .pipe(
                  tap((eventData: EventData) => {
                    if (eventData?.data) {
                      if (this.event.length > 0) {
                        this.setEventData(eventData);
                      }
                    }
                    this.isLoading = false;
                  }),
                  catchError(() => {
                    this.messageService.add({ severity: SlbSeverity.Error, summary: EVENTERROR });
                    this.isLoading = false;

                    return of<string>('');
                  }),
                  takeUntil(this.destroyed)
                )
            )
          )
        ),
        takeUntil(this.destroyed)
      )
      .subscribe();
  }

  private checkPagination(value: boolean): void {
    if (!this.isPaginated && value) {
      this.paginatedData.pageIndex = 0;
      this.paginatedData.pageSize = DashboardConstants.RECORDS_PER_PAGE;
      this.paginatedData.length = DashboardConstants.PAGE_NUMBER;
      this.recordsPerPage = DashboardConstants.RECORDS_PER_PAGE;
      this.pageNumber = DashboardConstants.PAGE_NUMBER;
    } else {
      this.isPaginated = false;
    }
  }

  private updateSelection(): void {
    this.violationDataList.forEach((data: EventDetails) => {
      data.isChecked = false;
    });
    this.selectedFiles.forEach((file: EventDetails) => {
      this.violationDataList.forEach((data: EventDetails) => {
        if (file.eventId === data.eventId) {
          data.isChecked = true;
        }
      });
    });
  }

  private downloadZipFile(url: string): void {
    const blob = new Blob([url], {
      type: 'application/zip',
    });
    const bloburl = window.URL.createObjectURL(blob);
    const filename = 'SLB Edge-Vision Intelligence-' + this.controllerId;
    const dwldLink = document.createElement('a');

    dwldLink.setAttribute('href', bloburl);
    dwldLink.setAttribute('download', filename + '.zip');
    dwldLink.setAttribute('target', '_blank');
    dwldLink.click();
    dwldLink.remove();
  }

  private calculateTimeBasedOnTimezone(date: Date): string {
    if (date) {
      const dateBdOnChosedTimezone = new DatePipe('en-Us').transform(date, 'EEEE, MMMM d, y, h:mm:ss a zzzz', this.currentZone);
      if (dateBdOnChosedTimezone) {
        const basedonCurrentTimezone: Date = new Date(dateBdOnChosedTimezone);

        return basedonCurrentTimezone.toISOString();
      }

      return '';
    }

    return '';
  }

  private checkTimeRange(): void {
    const eventTimeinms = this.eventTime.getTime();
    if (eventTimeinms > new Date().getTime() - this.SECONDS_IN_HOUR) {
      this.previousDaymode = HOUR;
      this.dayMode = HOUR;
      this.getDate(this.HOUR);
    } else if (eventTimeinms > new Date().getTime() - 24 * this.SECONDS_IN_HOUR) {
      this.previousDaymode = DAY;
      this.dayMode = DAY;
      this.getDate(this.DAY);
    } else if (eventTimeinms > new Date().getTime() - 168 * this.SECONDS_IN_HOUR) {
      this.previousDaymode = WEEK;
      this.dayMode = WEEK;
      this.getDate(this.WEEK);
    } else {
      this.previousDaymode = 'custom';
      this.dayMode = 'custom';
      this.endDate = new Date(eventTimeinms);
      this.startDate = new Date(this.endDate.getTime() - 24 * this.SECONDS_IN_HOUR);
    }
    this.getEvent();
  }

  private downloadData(blob: Blob): void {
    const dwldLink = document.createElement('a');
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    const filename = `${this.cameraName.replace(' ', '')} - Events - ${new Date().toLocaleString()}`;

    if (isSafariBrowser) {
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
    this.isDownloadStarted = false;
    this.messageService.clear();
  }

  private getqueryParameters(): void {
    let queryParams = sessionStorage.getItem('eventlink');
    this.eventStartDate = new Date().toISOString();
    if (queryParams?.includes('eventid')) {
      let arr = queryParams?.split('?');
      queryParams = arr[1];
      arr = queryParams.split('&');
      arr.forEach(element => {
        const param = element.split('=');
        if (param[0] === 'eventid') {
          this.eventId = Number(param[1]);
        } else if (param[0] === 'eventdate') {
          this.eventStartDate = new Date(Number(param[1].toString())).toISOString();
        }
      });
    }

    sessionStorage.removeItem('eventlink');
  }

  private setEventData(eventData: EventData): void {
    this.violationDataList = eventData?.data;
    this.totalRecords = eventData?.totalRecords;
    this.checkAll = false;
    this.violationDataList?.forEach(data => {
      data.cameraStatus = this.cameraStatus;
      data.equipmentName = this.cameraName;
      data.rigName = this.rigName;
      data.icon = this.dashboardService.getIconImg(data);
      data.label = this.dashboardService.getReason(data);
      data.rigState = this.dashboardService.getRigEventDetails(data);
      data.quality = this.dashboardService.formatLabel(data.quality ?? '');
      if (data?.isChecked) {
        data.isChecked = false;
      }

      return data;
    });
  }

  private convertToCsv(prevCsvData: string, objArray: EventDetails[], headerList: string[]): string {
    let str = '';
    if (!prevCsvData) {
      let row = '';
      headerList.forEach((value: string) => {
        value = this.addUnit(value);
        value = this.formatHeader(value);
        row += value.charAt(0).toUpperCase() + value.slice(1) + ',';
      });
      row = row.slice(0, -1);
      str += row + '\r\n';
    }

    str += this.extractData(objArray, headerList, this.currentZone);

    return str;
  }

  private addUnit(header: string): string {
    switch (header) {
      case BPOS:
        return BPOS + this.userSettingService.getUnit(BPOS_UNIT, this.unitSelected.unitData);
      case BVEL:
        return BVEL + this.userSettingService.getUnit(BVEL_UNIT, this.unitSelected.unitData);
      case RPM:
        return RPM + this.userSettingService.getUnit(RPM_UNIT, this.unitSelected.unitData);
      case SPPA:
        return SPPA + this.userSettingService.getUnit(SPPA_UNIT, this.unitSelected.unitData);
    }

    return header;
  }

  private formatHeader(header: string): string {
    switch (header) {
      case 'rigName':
        return 'Site';
      case 'gatewayName':
        return 'Gateway Name';
      case 'equipmentName':
        return 'Camera Name';
      case 'peopleLimit':
        return 'People limit';
      default:
        return header;
    }
  }

  private extractData(objArray: EventDetails[], headerList: string[], currentZone: string): string {
    let str = '';

    objArray.forEach((eventValues: EventDetails) => {
      let line = '';
      headerList.forEach((header: string) => {
        line += this.getPropertyValue(eventValues, header, currentZone) + ',';
      });
      line = line.replace(/,\s*$/, '');
      str += line + '\r\n';
    });

    return str;
  }

  private getPropertyValue(value: EventDetails, propertyValue: string, currentZone: string): string {
    switch (propertyValue) {
      case 'peopleCount':
        return value?.peopleCount?.toString() ?? '0';

      case 'peopleLimit':
        return value?.peopleLimit != null && value.peopleLimit !== 0 ? String(value.peopleLimit) : '';

      case 'confidence':
        return value?.confidence?.toString() ?? '0';

      case 'reason':
        if (value.rigState) {
          value.rigState = this.dashboardService.getRigEventDetails(value);
        }
        if (!value.rigState || value.rigState === CameraConstants.NoRigData || (value && value.workflowType === '')) {
          return CameraConstants.NoRigData;
        } else {
          let tag = this.dashboardService.getReason(value);
          tag += ': ' + value.rigState;
          tag = tag.replace(/,/g, '|');

          return tag;
        }
      case 'quality':
        let quality = '';
        if (value?.quality) {
          quality = this.dashboardService.formatLabel(value?.quality);
        }

        return quality;
      case 'category':
        return !value.category || value.category === NONE
          ? DashboardConstants.NOT_REVIEWED
          : value.category.charAt(0).toUpperCase() + value.category.slice(1).toLowerCase();

      case 'comment':
        return value.lastComment ? value.lastComment : '';

      case 'type':
        return this.dashboardService.getWorkFlowType(value) + ' events';

      case 'timestamp':
        const dateconversion = this.datePipe.transform(new Date(value.timestamp), 'MM/dd/yyyy hh:mm:ss a', currentZone);

        return dateconversion ? dateconversion : '';

      case 'imageFilename':
        const image = value.media.find(x => x.type === 'image');

        return image ? image.fileUrl.split('download/')[1] : '';

      case 'videoFilename':
        const video = value.media.find(x => x.type === 'video');

        return video ? video.fileUrl.split('download/')[1] : '';

      case 'BPOS':
        return value.rigData?.BPOS_m !== null && typeof value.rigData?.BPOS_m !== 'undefined' && !isNaN(value.rigData?.BPOS_m)
          ? this.setUnitSelected(value.rigData.BPOS_m, BPOS_UNIT)
          : '';

      case 'BVEL':
        return value.rigData?.BVEL_mps != null && typeof value.rigData?.BVEL_mps !== 'undefined' && !isNaN(value.rigData?.BVEL_mps)
          ? this.setUnitSelected(value.rigData.BVEL_mps, BVEL_UNIT)
          : '';

      case 'RPM':
        return value.rigData?.RPM !== null && typeof value.rigData?.RPM !== 'undefined' && !isNaN(value.rigData?.RPM)
          ? this.setUnitSelected(value.rigData.RPM, RPM_UNIT)
          : '';

      case 'SPPA':
        return value.rigData?.SPPA_Pa !== null && typeof value.rigData?.SPPA_Pa !== 'undefined' && !isNaN(value.rigData?.SPPA_Pa)
          ? this.setUnitSelected(value.rigData.SPPA_Pa, SPPA_UNIT)
          : '';

      default:
        return value ? (value[propertyValue as keyof EventDetails] as string) : '';
    }
  }

  private setUnitSelected(currValue: number, defaultUnit: string): string {
    const getSelectedUnit = this.userSettingService.getUnit(defaultUnit, this.unitSelected.unitData);

    return this.userSettingService.siToChosenUnit(currValue, defaultUnit, getSelectedUnit);
  }

  private getCameraWorkflow(): void {
    this.cameraProfileService.cameraWorkflow$
      .pipe(
        tap((workflow: string[]) => {
          let filterworkflow = [] as unknown as WORKFLOW_DETAILS[];
          if (workflow.length && this.workflows.length) {
            filterworkflow = this.workflows.filter(data => workflow.includes(data.value.toLowerCase()));
          }
          this.workflows = filterworkflow;
        }),
        takeUntil(this.destroyed)
      )
      .subscribe();
  }
}
